export default __webpack_public_path__ + "static/media/bloom.492647eb.png";